module.exports = __webpack_public_path__ + "img/telephone-minus-fill.24f92531.svg";